// ** React Imports
import { Fragment } from 'react'
import { Menu } from 'react-feather'

// ** Custom Components
import NavbarUser from './NavbarUser'
// import NavbarBookmarks from './NavbarBookmarks'
// ** Reactstrap Imports
import {
  NavItem,
  NavLink
} from 'reactstrap'

const ThemeNavbar = props => {
  // ** Props
  // const { skin, setSkin } = props
  const { setMenuVisibility } = props
  // const { skin, setSkin, setMenuVisibility } = props

  return (
    <Fragment>
      <div className='bookmark-wrapper d-flex align-items-center'>
        <ul className='navbar-nav d-xl-none'>
          <NavItem className='mobile-menu me-auto'>
            <NavLink className='nav-menu-main menu-toggle hidden-xs is-active' onClick={() => setMenuVisibility(true)}>
              <Menu className='ficon' />
            </NavLink>
          </NavItem>
        </ul>
        {/* <NavbarBookmarks setMenuVisibility={setMenuVisibility} /> */}
      </div>
      {/* <NavbarUser skin={skin} setSkin={setSkin} /> */}
      <NavbarUser />
    </Fragment>
  )
}

export default ThemeNavbar
